import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import type { Params } from '@angular/router';
import { take } from 'rxjs/operators';
import { LoggedInService } from '../logged-in.service';
import type { IUserSessionResponse } from '../logged-in.service';
import { SsoOptionsService } from '../sso-options.service';
import { DOCUMENT } from '@angular/common';
import { CbreLogger, CbreLoggerToken } from '@cbre/logger';

const PERMANENT_REDIRECT = 308;

@Component({
  selector: 'ng-sso-asd-callback',
  templateUrl: './asd-callback.component.html',
  styles: [],
  standalone: false,
})
export class AsdCallbackComponent implements OnInit {
  callbackParams: Params;

  loggedIn = true;

  constructor(
    route: ActivatedRoute,
    private http: HttpClient,
    private loggedInService: LoggedInService,
    private ssoOptions: SsoOptionsService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(CbreLoggerToken) private readonly logger: CbreLogger
  ) {
    this.callbackParams = route.snapshot.queryParams;
  }

  ngOnInit() {
    const { tokenExchangeUrl, successUrl = '' } = this.ssoOptions.options;
    const { code, state } = this.callbackParams;
    const successLoginCallback = this.onLoginSuccess(state || successUrl);
    const headers = { 'Access-Control-Allow-Origin': '*' };
    const options = { headers, params: { code } };
    this.http.get(tokenExchangeUrl, options).pipe(take(1)).subscribe({
      next: successLoginCallback,
      error: this.onLoginError,
    });
    // Setting alreadyRedirected true prevents the app from refreshing when entering the app for the first time without authentification.
    this.ssoOptions.alreadyRedirected = true;
  }

  private onLoginSuccess =
    (successUrl: string) =>
    (userSessionResponse: IUserSessionResponse): void => {
      const { options } = this.ssoOptions;
      this.loggedInService.setSession(userSessionResponse);
      // Refresh the whole page after setting session after login success forcing the app to use newly generated session.
      this.onPageRefresh(`${options.hostUrl}${successUrl}`);
    };

  private onLoginError = (errorResponse: HttpErrorResponse & { code?: number }): void => {
    this.logger.debug(errorResponse);
    // redirect response AND if message is a CEP url
    if (errorResponse.code === PERMANENT_REDIRECT && errorResponse.error?.message?.includes('miq.cbre.com')) {
      // message contains the redirected page
      this.document.location = errorResponse.error.message;
      return;
    }
    this.loggedIn = false;
  };

  //This method was created for testing purposes
  private onPageRefresh(url: string): void {
    this.document.location.assign(url);
  }
}
